import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import 'bootstrap'
// @ts-ignore
import VueGoogleCharts from 'vue-google-charts';

Vue.config.productionTip = false;
Vue.use(VueGoogleCharts);
var app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");


